/* eslint-disable */
/* tslint-disable */
// @ts-nocheck
import { inject, Service, service } from './di'
import { SessionStorageService } from './SessionStorageService'
import { EVTrackingService } from './EVTrackingService'
import { Flyer } from '../definitions/FlyerDefinitions'
import { ConfigService, Experience, RuntimeConfig } from './ConfigService'
import { LocationService } from './LocationService'

// appsflyer.com integration service
@service('appsflyerService')
export class AppsFlyerService extends Service {
    @inject evTracker: EVTrackingService
    @inject config: ConfigService
    @inject location: LocationService

    initialized = false

    isSmartNews = () => {
        const urlParams = new URLSearchParams(window.location.search)
        let synd = urlParams.get('synd')
        if (!synd) {
            const sessionStorageService = SessionStorageService.getInstance()
            synd = sessionStorageService.getItem('synd')
        }
        return synd === 'smartnews'
    }

    async init() {
        if (
            !this.isSmartNews() &&
            this.config.RUNTIME !== RuntimeConfig.DISTRIBUTION &&
            this.config.EXPERIENCE !== Experience.SDE &&
            (await this.location.isAllowedCountry()) &&
            !window.Cypress
        ) {
            // @ts-ignore
            !(function (t, e, n, s, a, c, i, o, p) {
                ;(t.AppsFlyerSdkObject = a),
                    (t.AF =
                        t.AF ||
                        function () {
                            ;(t.AF.q = t.AF.q || []).push(
                                [Date.now()].concat(
                                    Array.prototype.slice.call(arguments)
                                )
                            )
                        }),
                    (t.AF.id = t.AF.id || i),
                    (t.AF.plugins = {}),
                    (o = e.createElement(n)),
                    (p = e.getElementsByTagName(n)[0]),
                    (o.async = 1),
                    (o.src =
                        'https://websdk.appsflyer.com?' +
                        (c.length > 0
                            ? 'st=' + c.split(',').sort().join(',') + '&'
                            : '') +
                        (i.length > 0 ? 'af_id=' + i : '')),
                    p.parentNode.insertBefore(o, p)
            })(window, document, 'script', 0, 'AF', 'pba,banners', {
                pba: { webAppId: this.config.APPSFLYER_WEB_DEV_KEY },
            })
            this.initialized = true
        }
    }

    trackFlyerOpen() {
        this.recordEvent('flyer_open')
    }

    trackFlyerView() {
        this.recordEvent('flyer_view')
    }

    trackFlyerItem() {
        this.recordEvent('item_interaction')
    }

    trackAutocompleteHit() {
        this.recordEvent('autocomplete_click')
    }

    trackAddFavouriteEvent() {
        this.recordEvent('add_favorite')
    }

    trackFlyerEngagement(flyer: Flyer) {
        const status = this.evTracker.engagementStatus(flyer)
        if (status === 'billable') {
            this.recordEvent('premium_flyer_engagement')
        } else {
            this.recordEvent('flyer_engagement')
        }
    }

    private recordEvent(eventName: string) {
        if (this.initialized) {
            // @ts-ignore
            AF('pba', 'event', { eventType: 'EVENT', eventName })
        }
    }
}
/* eslint-enable */
/* tslint-enable */
